module.exports = __webpack_public_path__ + "media/recipes/143-959f9802.png";